<template>
<div>
  <v-row align="center" justify="center" style="padding:10px 30px 10px 30px">
    <draggable v-model="media" @start="drag=true" @end="drag=false" style="width:100%;" class="row align-center justify-center" >
      <v-col  v-for="(img, index) in media" :key="index" cols="4" md="2" lg="2" sm="3">                
          <v-hover v-slot:default="{ hover }">           
            <v-card flat class="mx-auto" @click="viewMedia(img)" :elevation="hover ? 16 : 2" v-if="img.preview.thumbnail">            
              <v-img
                :src="img.preview.thumbnail"
                :lazy-src="img.preview.thumbnail"      
                aspect-ratio="1"                          
                class="grey lighten-2"
              ></v-img>
            </v-card>           
            <v-card flat class="mx-auto" v-else>            
              <v-img
                :src="img.preview.thumbnail"
                :lazy-src="img.preview.thumbnail"      
                aspect-ratio="1"                          
                class="grey lighten-2"
                style="max-height:226px"
              ></v-img>
            </v-card>                                        
          </v-hover>
          <div style="width:100%; text-align:center;">
            {{img.preview.name}}.{{img.preview.format}} 
            <v-btn dark icon @click="deleteImage(index, img)">
              <v-icon dark color="red">cancel</v-icon>
            </v-btn>
          </div>           
      </v-col>
    </draggable>
  </v-row>
  <v-row align="center" justify="center" style="margin-bottom:20px;margin-top:20px;">         
    <v-col style="max-width:150px;max-width:150px;">
      <v-responsive :aspect-ratio="1">
        <v-card
          outlined
          flat
          tile
          style="height: 100%;min-width:100px"
          class="d-flex"
          @click="$refs.mediaUpload.click()"
        >
          <v-btn dark icon class="ma-auto">
            <v-icon dark color="primary">add</v-icon>
          </v-btn>
          <input
            type="file"
            name="images"
            style="display: none"
            ref="mediaUpload"
            id="fileToUpload"
            :accept="accept"
            @change="prepareUpload"
            :multiple="multiple || false"
          />
        </v-card>
      </v-responsive>      
    </v-col>
  </v-row>
  <v-dialog
    v-model="imageDialog"  
    width="600"
    @click:outside="modalClickOutSide"    
  >
    <v-card style="text-align:center;">
      <v-img v-if="mediaType === 'image'"
        :src="previewMedia"           
        class="grey lighten-2"      
      ></v-img>
      <div style="text-align:center;">
        <video class="custom-preview-img" id='postVdo' v-if="mediaType === 'vdo'" controls>             
            Your browser does not support the video tag.
        </video>
      </div>
    </v-card>
  </v-dialog>
  <v-dialog
      v-model="loadingDialog"      
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
</div>  
</template>
<script>
// import Jimp from 'jimp';
import { mapState } from 'vuex';
import config from '@/config';
import utils from '@/utils';
import draggable from 'vuedraggable'
// import campaignAPIs from '@/components/views/Campaign/campaignAPIs';
import btnDownload from '@/components/scoped/custom/BtnDownload.vue';
import campaignHelper from '@/components/views/Campaign/campaignHelper'
import CustomMediaV2 from '@/components/scoped/custom/CustomMediaV2';
export default {
  name: 'UploadMedia',
  components: {
    draggable,
    btnDownload,
    CustomMediaV2
  },
  data() {
    return {
      previewMedia: '',
      media: [],
      imageDialog: false,
      mediaType: '',
      loadingDialog: false,
      cldConfig: config.cldConfig,
      cld: null,
      cldFolderPath: 'POST SUBMISSIONS',
      campaignHelper
    };
  },
  props: {
    accept: String,
    limit: {
      type: Number,
      default: 1
    },
    listMedia: Array,
    influencer: Object,
    campaign: Object,
    multiple: Boolean
  },
  computed: {
    ...mapState({
      cldSignature: state => state.campaign.cldSignature
    })
  },
  watch: {
    media(newValue) {
      this.$emit('change', newValue);
    },
    listMedia(value) {
      this.media = value
    }
  },
  mounted() {
    console.log('File type accept', this.accept)
    this.cld = window.cloudinary.Cloudinary.new({ cloud_name: this.cldConfig.CLOUD_NAME });
  },
  methods: {
    prepareUpload(e) {
      const uploadedFiles = Object.keys(e.target.files).map(i => e.target.files[i]);
      uploadedFiles.forEach(element => {
        // console.log('🚀 ~ file: UploadMedia.vue ~ line 111 ~ prepareUpload ~ element', element)
        let type = element.type.split('/')[0];
        if (type !== 'video' && type !== 'image') {
          return this.$swal('File Type Not Supported, Please select a video or an image');
        }
        if (type === 'video') {
          if (element.size > 104857600) {
            let fileSize = element.size / (1024 * 1024)
            return this.$swal({
              title: 'File size',
              text: `Too big, maximum is 100MB. You file size is: ${fileSize.toFixed(2)} MB`,
              type: 'warning'
            });
          }
          return this.processVideo(element);
        } else {
          this.processImage(element);
        }
      });
    },
    processImage(image) {
      try {
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = e => {
          let buffer = e.target.result;
          let file = utils.func.dataURLtoFile(buffer, image.name);
          this.media.push({
            file,
            preview: {
              thumbnail: buffer,
              src: buffer,
              name: image.name
            }
          });
          // Nyein - temp remove img resize for issue
          // Jimp.read(buffer, (err, img) => {
          //   if (err) console.error(111, err);
          //   img
          //     .resize(500, Jimp.AUTO)
          //     .quality(100)
          //     .getBase64(Jimp.MIME_PNG, (err, buff) => {
          //       if (err) console.error(222, err);
          //       let file = utils.func.dataURLtoFile(buff, image.name);
          //       this.media.push({
          //         file,
          //         preview: {
          //           thumbnail: buffer,
          //           src: buffer,
          //           name: image.name
          //         }
          //       });
          //     });
          // });
        };
      } catch (error) {
        console.error(error);
        this.$swal({
          text: 'Error When processing iamge',
          type: 'error'
        });
      }
    },
    processVideo(element) {
      try {
        const reader = new FileReader();
        this.loadingDialog = true;
        reader.onload = () => {
          let blog = new Blob([reader.result], { type: element.type });
          let url = URL.createObjectURL(blog);
          let video = document.createElement('video');
          // if (element.type === 'video/quicktime') {
          //   this.media.push({
          //     file: element,
          //     preview: {
          //       src: url,
          //       thumbnail: '',
          //       name: video.name,
          //       video: true
          //     }
          //   });
          //   this.loadingDialog = false;
          //   return;
          // }
          let timeupdate = function() {
            if (snapImage()) {
              video.removeEventListener('timeupdate', timeupdate);
              video.pause();
            }
          };
          let snapImage = () => {
            var canvas = document.createElement('canvas');
            canvas.width = video.videoWidth * 0.25;
            canvas.height = video.videoHeight * 0.25;
            canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
            var image = canvas.toDataURL();
            // var success = image.length > 100000;
            this.media.push({
              file: element,
              preview: {
                src: url,
                thumbnail: image,
                name: video.name,
                video: true
              }
            });
            return true;
          };
          video.addEventListener('timeupdate', timeupdate);
          video.preload = 'metadata';
          video.src = url;
          // Load video in Safari / IE11
          video.muted = true;
          video.playsInline = true;
          var playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.then(_ => {
              // Do anything here after video played...
            })
            .catch(error => {
              // if video failed to play, juz add to media array
              console.log(error)
              this.media.push({
                file: element,
                preview: {
                  src: url,
                  thumbnail: '',
                  name: video.name,
                  video: true
                }
              });
            });
          }
          this.loadingDialog = false;
        };
        reader.readAsArrayBuffer(element);
      } catch (error) {
        console.error(error);
        this.$swal({ type: 'error', text: 'Error when processing video' });
      }
    },
    async deleteImage(imgIndex, img) {
      this.media.splice(imgIndex, 1);
      // let formData = new FormData()
      // formData.append('publicID', img.publicID)
      // formData.append('type', img.type)
      // await campaignAPIs.deleteCldFile(formData)
    },
    viewMedia(media) {
      this.imageDialog = true
      // this.previewMedia = media
      if (media.file.type.indexOf('image') !== -1) {
        this.mediaType = 'image'
        this.previewMedia = media.preview.src
      } else {
        this.mediaType = 'vdo'
        setTimeout(() => {
          let video = document.getElementById('postVdo')
          let file = media.file;
          let blobURL = URL.createObjectURL(file);
          video.src = blobURL
          if (media.file.type.indexOf('mp4') !== -1) {
            video.type = 'video/mp4'
          } else if (media.file.type.indexOf('quicktime') !== -1) {
            video.type = 'video/quicktime'
          }
          video.load()
        }, 700)
      }
    },
    modalClickOutSide() {
      if (this.mediaType === 'vdo') {
        let vdoCtrl = document.getElementById('postVdo')
        vdoCtrl.pause()
        vdoCtrl.currentTime = 0
        vdoCtrl.src = ''
        // URL.revokeObjectURL(vdoCtrl.src)
      }
    }
    // async processUpload(error, result) {
    //   if (!error && result && result.event === 'success') {
    //     let INFO = result.info
    //     this.media.push({
    //       publicID: INFO.public_id,
    //       file: INFO.secure_url,
    //       type: INFO.resource_type,
    //       preview: {
    //         thumbnail: INFO.thumbnail_url,
    //         src: INFO.thumbnail_url,
    //         name: INFO.original_filename,
    //         format: INFO.format,
    //         publicID: INFO.public_id
    //       }
    //     });
    //   } else if (error && error.status && error.status.includes('maximum allowed (300 MB)')) {
    //     this.myWidget.close()
    //     this.$swal({
    //       type: 'error',
    //       text: error.statusText
    //     });
    //     return
    //   } else if (error) {
    //     this.$swal({
    //       type: 'error',
    //       text: 'Failed to multiple contents'
    //     });
    //     return
    //   }
    // }
    // async openCloudinaryWidget(folder) {
    //   // init cloudinary object
    //   let tags = [this.campaign.name, 'tmp']
    //   await this.$store.dispatch('campaign/getCldSignature', {
    //     filters: {
    //       folder,
    //       source: 'uw', // upload widget
    //       tags
    //     }
    //   })
    //   this.myWidget = window.cloudinary.createUploadWidget(
    //     { cloudName: this.cldConfig.CLOUD_NAME,
    //       uploadPreset: this.cldConfig.UPLOAD_PRESET,
    //       folder,
    //       tags,
    //       thumbnailTransformation: [{ width: 320, height: 320, crop: 'fill' }],
    //       sources: ['local', 'url', 'google_drive', 'facebook', 'instagram'],
    //       api_key: this.cldConfig.API_KEY,
    //       uploadSignature: this.cldSignature.signature,
    //       uploadSignatureTimestamp: this.cldSignature.timestamp,
    //       eager_async: true,
    //       maxFileSize: 314572800, // 300 MB limit
    //       prepareUploadParams: async (cb, params) => {
    //         // if headers changed especially for google drive, regenerate signature
    //         params = [].concat(params)
    //         for (let [index, param] of params.entries()) {
    //           if (param.headers) {
    //             await this.$store.dispatch('campaign/getCldSignature', {
    //               filters: {
    //                 filename_override: param.filename_override,
    //                 folder: param.folder,
    //                 headers: param.headers,
    //                 source: 'uw',
    //                 tags,
    //                 timestamp: param.timestamp
    //               }
    //             })
    //           }
    //           params[index] = Object.assign({}, {
    //             signature: this.cldSignature.signature
    //           })
    //         }
    //         cb(params.length === 1 ? params[0] : params)
    //       }
    //     },
    //     this.processUpload
    //   );
    //   this.myWidget.open()
    // },
    // openCloudinaryUpload() {
    //   if (!this.influencer) {
    //     this.$swal({
    //       type: 'error',
    //       text: 'Influencer is required'
    //     })
    //     return
    //   }
    //   // this.loadingDialog = true
    //   this.openCloudinaryWidget(`${this.cldFolderPath}/@${utils.func.escapeCldSpecialChars(this.influencer.handle)}`)
    // }
  }
};
</script>
<style scoped>
  .custom-preview-img {
    min-height: 440px;
    max-height: 458px;
    max-width: 265px;
    object-fit: cover;
  }
</style>



// WEBPACK FOOTER //
// UploadMedia.vue?177e3572